
import Preloader from './preloader';

export default {
    Preloader
}